<template>
  <div>
    <ErrorBoundary>
      <EventGiftcardBookingIcons
        :first-label="labels[0]"
        :second-label="labels[1]"
        :third-label="labels[2]"
      />
      <Button
        :variant="isPrimaryButton || enableEmbedded ? 'contained' : 'outlined'"
        class="mt-4 ease duration-300 w-full py-2"
        :style="style"
        @click="gift"
      >
        {{
          bookGiftcardText
            ? bookGiftcardText
            : $t('product.show.checkout.bookGiftcard')
        }}
      </Button>
    </ErrorBoundary>
  </div>
</template>

<script setup lang="ts">
import parseGiftcardToCartItem from '~/utils/parseGiftcardToCartItem'
import type { EventDate, EventDescription } from '~/composables/types/event'
import { useAlgoliaConversion } from '~/composables/algolia/useAlgoliaConversion'
import { NUMBER_OF_EVENTS } from '~/composables/product/constants'
import type { CartItem } from '~/composables/types/cart'

const { toggleCartSidebar } = useUiState()
const { sendConversionEvents } = useAlgoliaConversion()
const { addItem, clear: clearCart } = useCartWithSubdomainLogic()
const { t, locale } = useI18n()
const {
  enableEmbedded,
  enableSubdomain,
  bookGiftcardText,
  // sectionTitle,
  selectedTime,
  isPrimaryButton,
  textColor,
  backgroundColor,
} = defineProps<{
  enableEmbedded?: boolean
  enableSubdomain?: boolean | null
  bookGiftcardText?: string
  // sectionTitle?: string
  selectedTime?: EventDate
  isPrimaryButton?: boolean
  textColor?: string
  backgroundColor?: string
}>()

const emit = defineEmits<{
  (e: 'add-item-to-cart', cartItem: CartItem): void
}>()

const eventData = inject('eventData') as EventDescription
const isSpecialGiftcardEvent = inject('isSpecialGiftcardEvent') as boolean

const style = computed(() => {
  return {
    ...(textColor && { color: `#${textColor}` }),
    ...(backgroundColor && { backgroundColor: `#${backgroundColor}` }),
  }
})

const gift = () => {
  const cartItem = parseGiftcardToCartItem(
    eventData,
    1,
    ref(selectedTime),
    isSpecialGiftcardEvent ? 'SPECIAL' : 'EVENT'
  )

  if (cartItem) {
    emit('add-item-to-cart', cartItem)
    if (enableEmbedded) {
      clearCart()
    }
    addItem(cartItem)
    toggleCartSidebar()

    sendConversionEvents(eventData.value)
  }
}

const eventCount = formattedNumberOfEvents(locale.value, NUMBER_OF_EVENTS)
const labels = computed(() => {
  if (enableEmbedded || enableSubdomain) {
    return [
      t('product.show.checkout.embeddedGiftcard.iconsLabels.first'),
      t('product.show.checkout.embeddedGiftcard.iconsLabels.second'),
      t('product.show.checkout.embeddedGiftcard.iconsLabels.third'),
    ]
  } else {
    return [
      t('product.show.checkout.giftcard.validity'),
      t('product.show.checkout.giftcard.forAnyKonfetti', { eventCount }),
      t('product.show.checkout.giftcard.giftExperiences'),
    ]
  }
})
</script>
